import { LOAD_MORE_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
import { appendConversationWithSeekToConditionResponse } from 'owa-mail-list-response-processor';
import { getBaseFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { findConversationWithSeekToCondition } from 'owa-mail-store/lib/services/findConversationWithSeekToCondition';
import { onLoadMoreRowsSucceeded, onLoadMoreRowsFailed } from '../onLoadMoreRowsCompleted';
import getConversationSortByProperty from '../../../utils/tables/getConversationSortByProperty';
/**
 * Load more conversations from the server
 * @param tableView to load
 */
export default function loadMoreConversationsFromServer(tableView) {
    var lastRowIndex = tableView.rowKeys.length - 1;
    var mailTableQuery = tableView.tableQuery;
    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    findConversationWithSeekToCondition(getBaseFolderId(mailTableQuery), tableView.rowKeys[lastRowIndex], LOAD_MORE_ROW_COUNT, mailTableQuery.viewFilter, getConversationSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName).then(function (responseMessage) {
        if (responseMessage.ResponseClass === 'Success') {
            onLoadMoreRowsSucceeded(tableView, responseMessage.Conversations, responseMessage.TotalConversationsInView, appendConversationWithSeekToConditionResponse);
        }
        else {
            onLoadMoreRowsFailed(tableView, responseMessage.ResponseCode);
        }
    }, function (error) {
        onLoadMoreRowsFailed(tableView);
    });
}
//# sourceMappingURL=loadMoreConversationsFromServer.js.map